import { Col, DatePicker, Form, Row, Table } from "antd";
import LineChart from "components/foundation/chart/chartType/LineChart";
import SelectFormItem from "components/foundation/selected/SelectFormItem";
import { useAuth } from "global/context/AuthenticationContext";
import { FaInfoCircle } from "react-icons/fa";
import { DASHBOARD } from "utils/Constants/Constants";
import { DashboardConstants } from "../constants/DashboardConstants";
import ColumTable from "../viewmodel/colum/Dashboard";
import useDashBoardModel from "../viewmodel/model/DashboardModel";

const { RangePicker } = DatePicker;

const Dashboard = () => {
  const { itemNav } = DashboardConstants.render();
  const { profile } = useAuth();

  const {
    loading,
    listHistory,
    datasets,
    labels,
    resultObject,
    defaultStartDate,
    currentDate,
    getListHistory,
    reload,
    onChange,
    handleNav,
  } = useDashBoardModel();

  const [form] = Form.useForm();

  return (
    <div className="mt-2 p-2 md:px-5">
      <div className="mb-2">
        <div style={{ fontSize: 17, fontWeight: 600, marginBottom: 15 }}>
          Dịch vụ
        </div>
        <div className="flex flex-wrap items-center justify-center md:justify-start  gap-x-6 gap-y-2">
          {itemNav.map((item) => (
            <div key={item.key} className="h-[135px] w-[95px]">
              <div
                className={`w-[90px] h-[85px] rounded-2xl shadow-md bg-white flex items-center justify-center ${item.disabled
                    ? "opacity-30 cursor-not-allowed"
                    : "cursor-pointer"
                  }`}
                onClick={() => !item.disabled && handleNav(item.path)}
              >
                <img
                  src={item.image}
                  alt="avatar"
                  className="w-[45px] h-[54px] object-contain"
                />
              </div>
              <div className="mt-2 text-center text-[14px]">{item.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="mb-2">
        <Form onValuesChange={onChange} form={form}
          initialValues={{
            date: [defaultStartDate, currentDate],
          }}
        >
          {/* <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 5 }}>
              {profile?.default_role === "MODERATOR" ||
              profile?.default_role === "SUPER_ADMIN"
                ? "Cửa hàng"
                : "Kênh bán"}
            </div>
            <SelectFormItem
              id="status"
              size="middle"
              form={form}
              onChange={(value) => {
                form?.setFieldsValue({ status: value });
              }}
              data={[{ key: -1, value: -1, label: "Tất cả" }, ...DASHBOARD]}
              className="w-[70%] md:w-[250px] mt-2"
            /> */}
          <div style={{ fontSize: 17, fontWeight: 600 }}>Tổng quan</div>
          <Form.Item name="date" className="mt-2 w-[70%] md:w-[250px]">
            <RangePicker
              // defaultValue={[defaultStartDate, currentDate]}
              format={["DD/MM/YYYY", "DD-MM-YYYY", "DDMMYYYY"]}
              placeholder={["Từ ngày", "Đến ngày"]}
              size="middle"
            />
          </Form.Item>
        </Form>
      </div>

      <Row gutter={[16, 16]}>
        <Col span={12}>
          <div className="bg-[white] flex flex-col gap-[8px] px-[20px] py-[10px] rounded-lg shadow-md text-[12px] md:text-[14px]">
            <div className="flex items-center gap-[5px]">
              <p>Tổng Sim đã ĐKTTTB </p> <FaInfoCircle />
            </div>
            <p className="text-[#0054A6] text-[16px] font-semibold">0</p>
          </div>
          <div className="bg-[white] flex flex-col gap-[8px] px-[20px] py-[10px] rounded-lg shadow-md text-[12px] md:text-[14px] mt-2">
            <p>Tổng số tiền hạn mức đã tiêu</p>
            <p className="text-[#34C759] text-[16px] font-semibold">0đ</p>
          </div>
        </Col>
        <Col span={12}>
          <div className="bg-[white] flex flex-col gap-[8px] px-[20px] py-[10px] rounded-lg shadow-md text-[12px] md:text-[14px]">
            <p>Tổng số thuê bao đã addkit</p>
            <p className="text-[#1D2129] text-[16px] font-semibold">0</p>
          </div>
          <div className="bg-[white] flex flex-col gap-[8px] px-[20px] py-[10px] rounded-lg shadow-md text-[12px] md:text-[14px] mt-2">
            <p>Tổng Sim đã ĐKTTTB</p>
            <p className="text-[#FF3B30] text-[16px] font-semibold">0đ</p>
          </div>
        </Col>
      </Row>
      <div className="mt-2 w-full h-full bg-[white] rounded-lg shadow-md p-4">
        <div className="flex justify-between items-center mb-[10px]">
          <p className="text-[20px] font-semibold w-[45%] md:w-[75%]">
            Biểu đồ
          </p>
          <div className="flex justify-end w-[55%] md:w-[25%]">
            <div className="flex items-center gap-1">
              <span className="w-2 h-2 rounded-full bg-[#34C759]"></span>
              <span className="text-[#1D2129] text-[11px] md:text-sm font-medium">
                Đã Đăng ký
              </span>
            </div>
            <div className="flex items-center gap-1">
              <span className="w-2 h-2 rounded-full bg-[#FF3B30]"></span>
              <span className="text-[#1D2129] text-[11px] md:text-sm font-medium">
                Chưa Đăng ký
              </span>
            </div>
          </div>
        </div>

        <LineChart labels={labels} datasets={datasets} />
      </div>
      <div className="mt-2 w-full h-full bg-[white] rounded-lg shadow-md p-4">
        <p className="text-[20px] font-semibold">Bảng Ranking cửa hàng</p>
        <Table
          loading={loading}
          size="middle"
          columns={ColumTable()}
          dataSource={listHistory}
        />
      </div>
    </div>
  );
};

export default Dashboard;
